import { CopiedEntityData } from "src/app/shared/interfaces/interfaces";

// **************************************************************************
// CLIPBOARD STATE
// **************************************************************************
export const CLIPBOARD_STORAGE_KEY = "yllw_copied_quote_entity";
export const CLIPBOARD_EVENT_NAME = "yllw-clipboard-change";

export interface ClipboardState {
    copiedEntity: CopiedEntityData | null;
}

export const initialClipboardState: ClipboardState = {
    copiedEntity: null,
};
